<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <router-link :to="{ name: 'area-tambah'}"  class="btn btn-primary" >Tambah Area</router-link>
        </div>
      </div>
        <div class="alert alert-warning" role="alert" v-show="infoHapus">
            {{infoHapusText}}
        </div>
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Area</h4>
                    <p class="card-category">Berikut daftar Area anda</p>
                  </div>
                  <div class="col-md-6" v-show="false">
                    <h2 class="card-title text-right">{{filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Jumlah User</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in area">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td>
                        <td><router-link :to="{ name: 'pelanggan-area', params: { id: u.id, nama:u.nama  }}"  class="text-info" >{{ u.jumlah }}</router-link></td>
                        <td>
                          <router-link :to="{ name: 'area-detail', params: { id: u.id, nama:u.nama  }}"  class="btn btn-sm btn-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>
                          <button v-show="isAllow()" @click="ShowHapus(index, u.id, u.jumlah, u.nama)" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button>
                        </td>
                        <td>
                          <transition name="slide-fade" mode="out-in">
                            <button v-if="showing == index" v-show="showing == index" class="btn btn-sm btn-success slide-enter-active" @click="hapusUser(index)"><i class="material-icons">check_circle</i> Ya</button>
                          </transition>
                        </td>
                      </tr>
                      <tr v-if="area == null">
                        <td></td>
                        <td>Tidak ada Data / Tidak ada Area</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>


    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'barcode': VueBarcode
  },
  data () {
    return {
      area: [],
      pelangganCari: [],
      cariByTelepon: false,
      
      showing: -1,
      telepon: '',
      dariTanggal: '',
      sampaiTanggal: '',
      statuse: '',
      filtered: '',

      // hapus
      idHapus: '',
      
      // cari kurir
      cariPelanggan: '',
      textCariPelanggan: '',
      textSalah: '',
      idPelanggan: '',
      namaPelanggan: '',

      // topup
      topup: '',
      password: '',


      // modal 
      modalTopup: false,
      preCari: true,

      isCari: false,
      infoHapus: false,
      infoHapusText: ''

    }
  },
  methods: {
    blank() {
      this.area = null;
      setTimeout(() => { 
        this.getData();
      }, 10000);
    },
    ShowHapus(index,id,jumlah,nama) {
        if (jumlah == 0) {
            this.showing = index;
            this.idHapus = id;
            this.infoHapus = false;
        } else {
            this.infoHapus = true;
            this.infoHapusText = "Area '"+nama+"' ini Tidak kosong, jadi tidak bisa di hapus ya gan.";
        }
    },
    simpanTopup() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('idPelanggan', this.idPelanggan);
      data.append('jumlah', this.topup);
      data.append('password', this.password);
      
      var apiUrl = 'TopupPelangganConfirmByTeller';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);
        if (x.status) {
          this.modalTopup = false;
          this.getData();
        } else {
          this.textSalah = x.pesan;
        }
      })
    },
    cariPelangganBtn() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.cariPelanggan);
      data.append('bulan', "0");
      data.append('type', "all");
      data.append('area', "null");
      data.append('tanggal', "null");
      
      var apiUrl = 'ListUserCari';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);
        return false;
        if (x.status) {
          this.preCari = !this.preCari;
          this.idPelanggan = x.data.id;
          this.namaPelanggan = x.data.nama;
        } else {
          //alert(x.pesan);
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    customFormatter (date) {
        return moment(date).format('YYYY-MM-DD');
    },
    cariTelepon() {
      this.cariByTelepon = true;
    },
    cariTeleponApi() {
      this.isCari = true;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.telepon);
      data.append('bulan', "0");
      data.append('type', "all");
      data.append('area', "null");
      data.append('tanggal', "null");
      
      var apiUrl = 'ListUserCari';
      this.PostData(data,apiUrl).then(x => {

        if (x.status == "true") {
          //this.preCari = !this.preCari;
          //this.idPelanggan = x.data.id;
          //this.namaPelanggan = x.data.nama;

          this.pelangganCari = x.data;
        } else {
          //alert(x.pesan);
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    hapusUser(item) {
      
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idHapus);
      
      var apiUrl = 'HapusArea';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.getData();
          this.showing = -1;
        } else {
          //alert(x.pesan);
        }
      })

    },
    getData() {
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.ListArea(); // 'ListArea';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.area = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    }
  },
  mounted () {
    this.getData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/area.vue